import React, { memo } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Box, Card, Stack, useTheme } from '@mui/material'

import customConfig from 'customConfig'
import Text from '../text/Text'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../text/CardHeading'
import { THEME_MODE } from '../../libs/qb-brand-web-components'

const AccountNumber = ({
  accountProfile: { authId },
  onCopyAccountNumber,
  t
}) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === THEME_MODE.DARK
  console.log(isDarkMode)
  return (
    <Card
      sx={{
        p: 3,
        textAlign: 'center',
        height: '100%'
      }}
    >
      <CardHeading
        title={t(customConfig.accountNumberLabel)}
        desc={t(customConfig.scanQrCodeDescLabel)}
      />
      <Box sx={{ my: { xs: 2, md: 3, height: 215 } }}>
        <QRCodeSVG
          value={authId}
          size={215}
          bgColor={isDarkMode ? '#121212' : '#ffffff'}
          fgColor={isDarkMode ? '#ffffff' : '#000000'}
          level='H'
        />
      </Box>
      <Text variant='caption' sx={{ color: 'text.disabled' }} label={authId} />
      <Stack alignItems='center'>
        <SubmitButton
          type='button'
          sx={{ mt: 3 }}
          size='default'
          label={t('user-account.copy-number')}
          onClick={onCopyAccountNumber}
        />
      </Stack>
    </Card>
  )
}

export default memo(AccountNumber)
